import { DApplicationLayerLike } from "./d-application-layer-like";
import { DApplicationLike } from "./d-application-like";

export interface DApplicationLayerStageLike {
	application: DApplicationLike;
	layer: DApplicationLayerLike;
}
